export enum Languages {
    ENGLISH = 'ENGLISH',
    SERBIAN = 'SERBIAN',
    FRENCH = 'FRENCH',
    GERMAN = 'GERMAN',
    DUTCH = 'DUTCH',
    ITALIAN = 'ITALIAN',
    JAPANESE = 'JAPANESE',
    SPANISH = 'SPANISH',
}

export enum BookingStatus {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
    AMENDED = 'AMENDED',
}
